import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import CardLayout from '../../../components/Layout/CardLayout';
import ReactDataTable from '../../../components/ReactDataTable/ReactDataTable';
import useFetch from '../../../hooks/useFetch';
import request from '../../../request/request';
import EditButton from '../../../components/Button/EditButton';
import DeleteButton from '../../../components/Button/DeleteButton';
import DeleteModal from '../../../components/Modal/DeleteModal';
import DetailsButton from '../../../components/Button/DetailsButton';
import CoursesDetailsModal from '../../../components/Website/Course/CoursesDetailsModal';

const CourseList = () => {
    const { result, isLoading, setRefresh } = useFetch(() => request.getAll('courses'));
    const navigate = useNavigate();

    console.log(result);

    const [modalOpen, setModalOpen] = useState('');
    const [selectedItem, setSelectedItem] = useState('');

    const columns = [
        {
            name: 'Title',
            wrap: true,
            center: 'true',
            selector: (row) => row?.title,
        },
        {
            name: 'Course Category',
            wrap: true,
            center: 'true',
            selector: (row) => row?.course_category?.map((item) => item?.title).join(', '),
        },
        {
            name: 'Course Images',
            wrap: true,
            width: '150px',
            cell: (row) => (
                <img
                    style={{ width: '100%' }}
                    src={`${process.env.REACT_APP_UPLOAD_URL}/website/${row?.img}`}
                    alt='side Img'
                />
            ),
        },

        // {
        //   name: "Sort Description",
        //   wrap: true,
        //   center: "true",
        //   selector: (row) => row?.sort_description,
        // },
        // {
        //   name: "Description",
        //   wrap: true,
        //   center: "true",
        //   cell: (row) => (
        //     <div dangerouslySetInnerHTML={{ __html: row?.long_description }} />
        //   ),
        // },

        {
            name: 'Status',
            center: 'true',
            selector: (row) => (row?.status === 1 ? 'Active' : 'InActive'),
        },
        {
            name: 'Action',
            center: 'true',
            cell: (row) => (
                <div>
                    <DetailsButton
                        onClick={() => {
                            setModalOpen('details');
                            setSelectedItem(row);
                        }}
                    />
                    <EditButton
                        onClick={() => navigate(`/dashboard/website/courses/edit/${row?.id}`)}
                    />
                    <DeleteButton
                        onClick={() => {
                            setModalOpen('delete');
                            setSelectedItem(row);
                        }}
                    />
                </div>
            ),
        },
    ];

    // delete function

    const abotUsDeleteHandler = () =>
        request.delete('courses', selectedItem?.id, () => {
            setModalOpen('');
            setRefresh((prev) => !prev);
        });

    return (
        <CardLayout
            title='Course List'
            buttonTitle='Add New Course'
            addButtonHandler={() => navigate('/dashboard/website/courses/add')}
        >
            <ReactDataTable columns={columns} data={result} pending={isLoading} />

            {/* delete about us */}

            {modalOpen === 'delete' && (
                <DeleteModal
                    isOpen={modalOpen === 'delete'}
                    onClose={() => setModalOpen('')}
                    handleDelete={abotUsDeleteHandler}
                />
            )}

            {/* course details modal  */}

            {modalOpen === 'details' && (
                <CoursesDetailsModal
                    isOpen={modalOpen === 'details'}
                    onClose={() => {
                        setModalOpen('');
                        setSelectedItem('');
                    }}
                    courseData={selectedItem}
                />
            )}
        </CardLayout>
    );
};

export default CourseList;
